import { render } from "./SimpleBanner.vue?vue&type=template&id=29d08d4e"
import script from "./SimpleBanner.vue?vue&type=script&lang=js"
export * from "./SimpleBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__